// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__5QVwl","row":"styles_row__3Imf2"};